<template>
  <modal
    title="Add Sale"
    size="side"
    :open="open"
    @close="closeModal"
  >
    <div v-if="display === 'start'">
      <div class="grid">
        <cta-card
          icon="content_paste"
          title="Paste eBay Item ID"
          description="Paste in the eBay Item ID of missing sales to add them to the Sales History."
          @click="display = 'ebay'"
        />

        <cta-card
          v-if="isStaff"
          icon="file_upload"
          title="Admin Manual Sale"
          description="Admins can use this to manually add a sale to the Sales History."
          @click="addManualSale"
        />

        <cta-card
          icon="add"
          title="Submit Private Sale"
          description="Submit a private sale for approval."
          @click="submitPrivateSale"
        />
      </div>
    </div>

    <form v-if="display === 'ebay'" @submit.stop.prevent="submitEbay">
      <text-input
        v-model.trim="ebayItemId"
        label="eBay Item ID"
      />

      <div class="button-row">
        <btn
          type="submit"
          :loading="submitting"
          :disabled="disabled"
          loading-text="Submitting"
        >
          Submit
        </btn>

        <btn kind="secondary" @click="display = 'start'">
          Back
        </btn>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as Sentry from '@sentry/vue';

import { saleService } from '@/services';

export default {
  data() {
    return {
      open: false,
      display: 'start',
      ebayItemId: '',
      submitting: false,
    };
  },

  mounted() {
    this.$bus.$on('add-sale-side', this.handle);
  },

  beforeDestroy() {
    this.$bus.$off('add-sale-side', this.handle);
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    ...mapGetters({
      isStaff: 'isStaff',
    }),

    disabled() {
      if (this.display === 'ebay') {
        return !this.ebayItemId;
      }

      return false;
    },
  },

  methods: {
    handle() {
      this.open = true;
    },

    async submitEbay() {
      if (this.disabled) {
        return;
      }

      this.submitting = true;

      try {
        let itemId = this.ebayItemId;

        if (itemId.includes('http')) {
          const matches = itemId.match(/\d{12}/);

          if (matches && matches.length) {
            itemId = matches[0];
          }
        }

        await saleService.submitEbayItemId(itemId, this.user.uid);

        this.$toasted.success('The eBay sale has been added for review.');
        this.closeModal();
      } catch (e) {
        this.$toasted.error('Error submitting the sale');
        Sentry.captureException(e);
      }

      this.submitting = false;
    },

    async submitPrivateSale() {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSfz17HEL-gQF-xmneWhpTwVU7ODxhMXef2No1RDvIyz6KC-Dg/viewform', '_blank');
    },

    async addManualSale() {
      this.$bus.$emit('sales-history-item-edit', null);
      this.closeModal();
    },

    reset() {
      this.ebayItemId = '';
      this.display = 'start';
    },

    closeModal() {
      this.reset();
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-gap: $gp;
  grid-template-columns: repeat(1, 1fr);
}
</style>
